import { render, staticRenderFns } from "./meetdetails.vue?vue&type=template&id=2d6cddda&scoped=true&"
import script from "./meetdetails.vue?vue&type=script&lang=js&"
export * from "./meetdetails.vue?vue&type=script&lang=js&"
import style0 from "./meetdetails.vue?vue&type=style&index=0&id=2d6cddda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cddda",
  null
  
)

export default component.exports